import React from "react"
import { Heading, Text } from "@atoms"
import { Link } from "gatsby"
import { theme } from "@theme"
import { wordTime } from "@utils/wordTime"
import cardPlaceholderImg from "./card-placeholder.jpg"
import { Container, CardContainer } from "./styles/Card.styled"
import { InlineLink } from "../Resources/ResourceCardInlineLink"
import OptimizedImage from "../../utils/optimizedImage"
import { ConditionalWrapper } from "../../atoms/ConditionalWrapper"

function truncate(input) {
  if (input.length > 130) {
    return input.substring(0, 130) + "..."
  }
  return input
}

export const Card = ({
  title,
  categories,
  description,
  link,
  gatsbyImage,
  featuredImg,
  border,
  blogBody,
  className,
  alt,
  type,
  pdfEmbedLink,
}) => {
  let category
  if (categories) {
    category = categories[0]?.title.toLowerCase()
  }
  return (
    <Container type={type}>
      <ConditionalWrapper
        condition={link}
        wrapper={children => (
          <Link style={{ padding: "0px", textDecoration: "none" }} to={link}>
            {children}
          </Link>
        )}
      >
        <CardContainer
          data-comp={Card.displayName}
          theme={theme}
          border={border}
          className={className}
        >
          <div className="img-wrapper">
            <OptimizedImage
              image={gatsbyImage}
              src={featuredImg || cardPlaceholderImg}
              alt={alt || title}
            />
          </div>
          {categories && (
            <p
              style={{
                margin: "4px 0px 12px 0px",
                padding: "5px 10px",
                width: "fit-content",
                display: "inline-block",
                backgroundColor: categories[0].backgroundColor || "#ddd",
                color: categories[0]?.fontColor || "#1B1B1B",
                fontSize: "12px",
                textTransform: "uppercase",
                fontWeight: 700,
                letterSpacing: "1px",
                borderRadius: "35px",
              }}
            >
              {categories[0]?.title}
            </p>
          )}
          {title && (
            <Heading
              headingSize="H6"
              style={{
                marginBottom: "8px",
              }}
              className="line-clamp-2"
            >
              {title}
            </Heading>
          )}
          {description && <Text>{truncate(description)}</Text>}
          <div
            style={{
              marginTop: "auto",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
            }}
          >
            {category && (
              <InlineLink
                category={
                  category === "guide" && pdfEmbedLink ? "guides" : category
                }
              />
            )}
            {blogBody?.raw && (
              <p className="card--read-time">{wordTime(blogBody?.raw)}</p>
            )}
          </div>
        </CardContainer>
      </ConditionalWrapper>
    </Container>
  )
}

Card.displayName = "Card"
